// Environment config
export const version = "%BUILDVERSION%";
export const env = "production";
export const flavor = "CashPoint";
export const APPOpenUrl = "cp://";
export const midOkami = "okami";
export const stripeKey = "pk_live_51PYzGJDUDDYvYAi6qEeuM7roC5qkWwukuppk0qZurW2Os9mYfqGyIXYEKsUl3TtagYNBGZruVcQrmO0rufzwMQ4D00B11W6sKY";
export const stripeSGKey = "";
export const adyenClientKey = "";

export const connectIdParticipantsUri = 'https://data.directory.connectid.com.au/participants';
export const connectIdRpLogoUrl = 'https://data.directory.connectid.com.au/logos/5e197ad7-6a78-4496-b09b-a5f668f65535/softwarestatements/a6b3d1f9-5466-463c-b25b-b52a43ebb760.png';



